import apiClient from './client';
import type { AuthResponse, FeatureCatalogEntry, LoginRequest, RegisterRequest, User } from '../types/auth';

export const authApi = {
  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  // /api/auth/me returns the flat me-shape with accessibleFeatures embedded.
  getCurrentUser: async (): Promise<User & { accessibleFeatures: FeatureCatalogEntry[] }> => {
    const response = await apiClient.get<User & { accessibleFeatures: FeatureCatalogEntry[] }>(
      '/auth/me'
    );
    return response.data;
  },

  // Feature 011 — forced-change variant of /api/users/me/change-password.
  // Server clears must_change_password atomically with the hash update.
  changeForcedPassword: async (newPassword: string): Promise<void> => {
    await apiClient.post('/users/me/change-password', { newPassword });
  },

  // Feature 015 — record the explicit logout server-side (FR-005). Best-effort:
  // the caller invokes this before clearing the local token so the request still
  // carries the bearer header; failures are ignored so logout always proceeds.
  logout: (): void => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config = { skipErrorRedirect: true } as any;
    apiClient.post('/auth/logout', {}, config).catch(() => {
      /* best-effort */
    });
  },
};
